<template>
  <b-form>
    <!-- DATOS ACADÉMICOS -->
    <b-row class="mt-2">
      <!-- LEYENDA -->
      <b-col md="12">
        <b-alert
          variant="primary"
          show
        >
          <div class="alert-body">
            <p>
              En caso de que su registro corresponda al estudio de una Especialidad, por favor todos los campos son obligatorios y será necesario contar con los documentos oficiales que respalden los datos capturados ya que se solicitarán para su validación.
            </p>
            <p>
              Si su registro es para estudiar un diplomado, los únicos campos a llenar es "Último grado de estudios" y en caso de seleccionar grado igual o superior a licenciatura, indicar el dato en el campo "Licenciatura de la cual egresó".
            </p>
          </div>
        </b-alert>
      </b-col>

      <!-- PLAN DE ESTUDIOS -->
      <b-col md="6">
        <b-form-group>
          <b-form-input
            v-model="planEstudiosCargado.nombre"
            placeholder="Plan de estudios"
            disabled
          />
        </b-form-group>
      </b-col>

      <!-- GRADO ACADÉMICO -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="grado académico"
            rules="required"
          >
            <v-select
              v-model="academico.nivel_educativo"
              :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
              :options="nivel_educativo"
              placeholder="Seleccione último grado de estudios"
              label="nombre"
              :clearable="false"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- TIPO DE ADMISIÓN -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="tipo de admisión"
            rules="required"
          >
            <v-select
              v-model="academico.tipo_admision"
              :class="{ 'form-control is-invalid p-0' : (errors.length > 0 ? false:null) == false }"
              :options="tipo_admision"
              placeholder="Seleccione el tipo de admisión"
              label="nombre"
              :clearable="false"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- LICENCIATURA DE LA CUAL EGRESÓ -->
      <b-col md="6">
        <b-form-group>
          <b-form-input
            v-model="academico.carrera"
            placeholder="Licenciatura de la cual egresó"
            :disabled="!isDisabledInputByAcademicLevel"
          />
        </b-form-group>
      </b-col>

      <!-- INSTITUCIÓN EDUCATIVA -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="institución educativa"
            rules="min:3"
          >
            <b-form-input
              v-model="academico.institucion_educativa"
              :state="errors.length > 0 ? false:null"
              placeholder="Institución educativa donde se obtuvo título/cédula"
              :disabled="!isDisabledInputByAcademicLevel"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- ENTIDAD FEDERATIVA DE TITULACIÓN -->
      <b-col md="6">
        <b-form-group>
          <v-select
            v-model="academico.efTitulacion"
            :options="entidadesFederativas"
            placeholder="Entidad federativa de titulación"
            label="nombre"
            :clearable="false"
            :disabled="!isDisabledInputByAcademicLevel"
          />
        </b-form-group>
      </b-col>

      <!-- CÉDULA -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="cédula"
            rules="max:10"
          >
            <b-form-input
              v-model="academico.cedula"
              :state="errors.length > 0 ? false:null"
              placeholder="Número de cédula de la licenciatura de la cual egresó"
              :disabled="!isDisabledInputByAcademicLevel"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

      <!-- FECHA DE EXPEDICIÓN DE TÍTULO -->
      <b-col md="6">
        <b-form-group>
          <validation-provider
            #default="{ errors }"
            name="fecha de expedición"
          >
            <cleave
              v-model="academico.fechaExpedicion"
              :options="cleaveOptions"
              :raw="false"
              class="form-control"
              placeholder="Fecha de expedición de cédula (YYYY-MM-DD)"
              :class="{ 'is-invalid' : (errors.length > 0 ? false:null) == false }"
              :state="errors.length > 0 ? false:null"
              :disabled="!isDisabledInputByAcademicLevel"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>
      </b-col>

    </b-row>
  </b-form>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import vSelect from 'vue-select'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  required, email, confirmed, password,
} from '@validations'
import Cleave from 'vue-cleave-component'
import { getData } from '@core/utils/http/general'
import {
  BRow,
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BAlert,
} from 'bootstrap-vue'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ref, onMounted, computed } from '@vue/composition-api'

export default {
  components: {
    // FormWizard,
    // TabContent,
    BRow,
    BCol,
    // BBadge,
    BForm,
    BFormGroup,
    BFormInput,
    BAlert,
    vSelect,
    Cleave,
    ValidationProvider,
  },
  props: {
    planEstudiosCargado: {
      type: Object,
      required: true,
      default: () => {},
    },
    // eslint-disable-next-line vue/prop-name-casing
    nivel_educativo: {
      type: Array,
      required: true,
      default: () => [],
    },
    // eslint-disable-next-line vue/prop-name-casing
    tipo_admision: {
      type: Array,
      required: true,
      default: () => [],
    },
    // eslint-disable-next-line vue/prop-name-casing
    ciclo_admision: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  setup() {
    const toast = useToast()
    const cleaveOptions = {
      date: true,
      delimiter: '-',
      datePattern: ['Y', 'm', 'd'],
    }
    const entidadesFederativas = ref([])
    const academico = ref({
      nivel_educativo: null,
      carrera: '',
      tipo_admision: {
        descripcion: null,
        id: 3,
        nombre: 'Inscripción',
      },
      cedula: '',
      institucion_educativa: '',
      fechaExpedicion: '',
      efTitulacion: null,
    })
    const HIGHER_ACADEMIC_LEVEL = [3, 8, 4, 10] // ID de Licenciatura (3), Maestría (8), Doctorado (4), Técnico Superior Universitario (10)

    const isDisabledInputByAcademicLevel = computed(() => HIGHER_ACADEMIC_LEVEL.includes(academico.value.nivel_educativo?.id))

    const fetchEf = async () => {
      try {
        const response = await getData({ action: 2 })

        if (response.status !== 200) throw new Error(response.statusText)

        const { status, message, data } = response.data

        if (status !== 200) throw new Error(message)

        entidadesFederativas.value = data
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Catálogo de entidades federativas',
            text: error.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    }

    onMounted(() => {
      fetchEf()
    })

    return {
      cleaveOptions,
      required,
      password,
      email,
      confirmed,

      academico,
      entidadesFederativas,
      isDisabledInputByAcademicLevel,
    }
  },
}
</script>
